import type { InfoDoc } from '../infoContent';

/**
 * プライバシーポリシー。
 *
 * 本サービスは認証基盤に Google
 * LLC の Firebase、運用基盤に Microsoft Azure、利用解析に Application Insights を
 * 利用しており、その旨を記載しています。利用する外部サービスを変更した場合は本文も
 * 更新してください。法的効力に関わる文書のため、公開前に専門家の確認を推奨します。
 */
export const PRIVACY_DOC: InfoDoc = {
  title: 'プライバシーポリシー',
  sections: [
    {
      body: [
        'Ashiken AI Labs（以下「運営者」といいます。）は、運営者が提供するチャットサービス「ChocoMesse」（以下「本サービス」といいます。）における利用者の情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます。）を定めます。',
      ],
    },
    {
      heading: '第1条（取得する情報）',
      body: [
        '本サービスは、利用者のプライバシーに配慮し、必要最小限の情報のみを取得します。',
        '(1) アカウント登録情報：利用者が任意にアカウント登録を行う場合に取得するメールアドレス等の認証情報。認証基盤として Google LLC の Firebase Authentication を利用します。',
        '(2) 合言葉：合言葉は利用者の端末（ブラウザ）上で暗号学的にハッシュ化されたうえで送信されるため、運営者は合言葉そのもの（平文）を取得・保存しません。',
        '(3) チャット情報：ルーム内で送受信されるメッセージ、ニックネーム、送受信日時、既読状態等。',
        '(4) 利用者が設定する情報：表示名、テーマ、アイコン設定、テンプレート、NGワード、メッセージ制限等の各種設定。',
        '(5) 技術情報：アクセスログ、IPアドレス、ブラウザの種類、Cookie 及びローカルストレージに保存される情報、サービスの品質向上・障害解析のための利用状況等。利用状況の解析には Microsoft Corporation の Application Insights を利用する場合があります。',
      ],
    },
    {
      heading: '第2条（利用目的）',
      body: [
        '運営者は、取得した情報を次の目的のために利用します。',
        '・本サービスの提供、維持、保護及び改善のため',
        '・利用者の認証及びルーム管理機能の提供のため',
        '・不正利用の防止及びセキュリティの確保のため',
        '・障害・不具合の解析及びサービス品質の向上のため',
        '・利用者からのお問い合わせに対応するため',
      ],
    },
    {
      heading: '第3条（第三者提供）',
      body: [
        '運営者は、次のいずれかに該当する場合を除き、あらかじめ利用者の同意を得ることなく、取得した個人情報を第三者に提供しません。',
        '・法令に基づく場合',
        '・人の生命、身体又は財産の保護のために必要があり、本人の同意を得ることが困難な場合',
        '・国の機関若しくは地方公共団体又はその委託を受けた者への協力が必要な場合',
      ],
    },
    {
      heading: '第4条（業務委託・外部サービスの利用）',
      body: [
        '運営者は、本サービスの提供のため、その運用基盤としてクラウドサービス事業者（Google LLC、Microsoft Corporation 等）を利用しており、取得した情報の取扱いの全部又は一部をこれらの事業者に委託する場合があります。この場合、運営者は委託先に対して必要かつ適切な監督を行います。',
      ],
    },
    {
      heading: '第5条（安全管理措置）',
      body: [
        '運営者は、取得した情報の漏えい、滅失又は毀損の防止その他の安全管理のために、必要かつ適切な措置を講じます。合言葉については、前記のとおり端末側でのハッシュ化により平文を保持しない設計を採用しています。',
      ],
    },
    {
      heading: '第6条（情報の保有期間）',
      body: [
        '運営者は、利用目的の達成に必要な期間、情報を保有します。ルーム内のメッセージは、当該合言葉に対応するルームが存在する限り保持されます。利用者が別の合言葉で新たなルームの利用を開始した場合でも、以前のルーム及びその会話内容はサーバー上に保持され、当該合言葉を知る者は引き続きアクセスできます。会話内容の削除を希望する場合は、ログインの上、当該ルームを作成したオーナーがルームを削除することにより行うことができます。',
      ],
    },
    {
      heading: '第7条（開示・訂正・利用停止等）',
      body: [
        '利用者は、運営者に対し、自己の個人情報の開示、訂正、追加、削除、利用停止等を請求することができます。請求を希望する場合は、第9条のお問い合わせ窓口までご連絡ください。',
      ],
    },
    {
      heading: '第8条（Cookie 等の利用）',
      body: [
        '本サービスは、利用者の利便性向上及びログイン状態の維持等のために、Cookie 及びブラウザのローカルストレージを使用します。利用者はブラウザの設定によりこれらを無効化できますが、その場合、本サービスの一部機能が利用できないことがあります。',
      ],
    },
    {
      heading: '第9条（お問い合わせ窓口）',
      body: [
        '本サービス及び本ポリシーに関するお問い合わせは、次の窓口までご連絡ください。',
        '連絡先：ashiken.ai.labs@gmail.com',
      ],
    },
    {
      heading: '第10条（プライバシーポリシーの変更）',
      body: [
        '運営者は、必要に応じて本ポリシーを変更することがあります。変更後の本ポリシーは、本サービス上に表示した時点から効力を生じるものとします。',
      ],
    },
    {
      body: [
        '制定日：2026年6月14日',
      ],
    },
  ],
};
